import { render, staticRenderFns } from "./AppAlertsCoa.vue?vue&type=template&id=3df693f8&scoped=true&"
import script from "./AppAlertsCoa.vue?vue&type=script&lang=js&"
export * from "./AppAlertsCoa.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsCoa.vue?vue&type=style&index=0&id=3df693f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df693f8",
  null
  
)

export default component.exports